import type { API } from 'chessboard/api/config/types';
import type { Move } from 'chessboard/model/move/types';
import { Core } from 'chessboard/core/config/types';
import { tryMovingBackward } from 'chessboard/api/model/try-moving-backward';

/**
 * Create the moveBackward method.
 */
export function createMoveBackward(context: API.Context) {
  return function moveBackward(
    selectContinuationMovesOrMoveBackwardParams?: Move.Backward | boolean,
  ): API.Response {
    const { respond, api, game } = context;

    const { selectContinuationMoves, steps } = getMoveBackwardParameters(
      selectContinuationMovesOrMoveBackwardParams,
    );

    if (steps < 1) {
      return null;
    }

    const { firstStepData, success, endIds, endBughouseIndex } = tryMovingBackward({
      context,
      selectContinuationMoves,
      steps,
    });

    // return early if only 1 step made or first step fails
    if (steps === 1 || firstStepData?.plyDiff !== -1) {
      if (endBughouseIndex !== null) {
        // @ts-ignore
        game.selectBughouseMove(endBughouseIndex);
      } else {
        game.selectPosition(endIds.move, endIds.line);
      }
      return respond(Core.APIEvents.MoveBackward, firstStepData);
    }

    // multiple steps failed
    if (!success) {
      return respond(Core.APIEvents.MoveBackward, null);
    }

    // multiple steps succeeded
    return api.selectNode(endIds.line, endIds.move);
  };
}

/**
 * Parse move backward parameters
 */
function getMoveBackwardParameters(
  selectContinuationMovesOrMoveBackwardParams?: Move.Backward | boolean,
) {
  let moveBackwardParams: Move.Backward = {};
  let select;

  if (typeof selectContinuationMovesOrMoveBackwardParams === 'object') {
    moveBackwardParams = selectContinuationMovesOrMoveBackwardParams;
  } else {
    select = selectContinuationMovesOrMoveBackwardParams;
  }

  const { selectContinuationMoves, steps } = moveBackwardParams;

  return {
    selectContinuationMoves: selectContinuationMoves ?? select ?? false,
    steps: steps ?? 1,
  };
}
